import { Controller } from "stimulus"
import { nextFrame } from "../helpers"

export default class extends Controller {
  static targets = ["planInput", "planDescription"]

  initialize() {
    this.update()
  }

  async update() {
    const { selectedPlan } = this

    await nextFrame()

    for (const target of this.planDescriptionTargets) {
      target.hidden = target.dataset.plan != selectedPlan
    }
  }

  select({ detail: { credits } }) {
    const plans = this.planInputTargets
    const plan = plans.find((plan) => Number(plan.dataset.credits) >= credits) || plans.at(-1)
    plan.checked = true
    this.update()
  }

  get selectedPlan() {
    return this.planInputTargets.find((input) => input.checked).value
  }
}
